import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './all.min.css';
import './chatbot.css';
import './enhanced-components.css';
import './enterprise-dashboard.css';
import './nxt-header.css';
import './nxt-humans-styles.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
